import React, { CSSProperties } from 'react';
import './index.scss';

interface ITokenProgressBarProps {
  percent: number;
  className?: string;
}

const TokenProgressBar: React.FC<ITokenProgressBarProps> = ({
  percent,
  className = '',
}) => {
  const isExceeded = percent >= 100;
  const fillWidth = Math.min(Math.max(percent, 0), 100);
  const fillRatio = fillWidth / 100 || 0.001;

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const fillStyle: CSSProperties = {
    width: `${fillWidth}%`,
    '--fill-ratio': fillRatio,
  } as CSSProperties;

  return (
    <div className={`dba-token-progress ${className}`.trim()}>
      <div className="dba-token-progress__track">
        {isExceeded ? (
          <div
            className="dba-token-progress__fill dba-token-progress__fill--danger"
            style={{ width: `${fillWidth}%` }}
          />
        ) : (
          <div className="dba-token-progress__fill" style={fillStyle}>
            <div className="dba-token-progress__fill-gradient" />
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(TokenProgressBar);
